import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appUIReducer from 'features/appUI/slice';
import reportsReducer from 'features/reports/slice';
import { baseApi } from 'lib/rtkQuery/baseApi';

export const store = configureStore({
  reducer: {
    baseApi: baseApi.reducer,
    ui: appUIReducer,
    reports: reportsReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['scanner.onScan', 'modals'],
        ignoredActionPaths: ['payload.onScan', 'payload.element'],
      },
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
